<!--  -->
<template>
  <div>
    <div style="float: right">
      <!-- <el-button plain type="primary" @click="addRules">新增打卡规则</el-button> -->
      <el-button plain class="addbutton" type="primary" @click="addConfig">拉取配置</el-button>
    </div>

    <el-table :cell-style="{ 'text-align': 'center' }" border :data="tableData" v-loading="loading" style="width: 100%" :header-cell-style="rowClass">
      <el-table-column align="center" prop="corp_name" label="企业名称" width="280" />
      <el-table-column align="center" prop="group_name" label="配置名称" width="280" />
      <el-table-column align="center" prop="group_type_text" label="配置类型" width="280" />
      <el-table-column align="center" prop="checkin_date" label="考勤规则">
        <template slot-scope="scope">
          <div v-for="(item, i) of scope.row.checkin_date" :key="i">{{ workdays(item.work_days) }}（{{ checkTime(item.checkin_time) }}）</div>
        </template>
      </el-table-column>
      <!-- <el-table-column align="center" label="操作">
        <template slot-scope="scope">
          <el-button type="primary" size="mini" @click="editConfig(scope.row)">修改</el-button>
        </template>
      </el-table-column> -->
    </el-table>

    <pagination-right :current-page="query.page" :total="total" @size-change="fetchPageSize" @current-change="fetchCurrentPage" />
    <el-dialog title="拉取配置信息" :close-on-click-modal="false" :visible.sync="configDialog" :destroy-on-close="true" :append-to-body="true" width="40%">
      <div>
        <pullConfigDialog ref="configdialogview" @update="update" />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import PaginationRight from '@/components/PaginationRight/index.vue'
import { clockList } from '@/api/tencentAccountIni'
import pullConfigDialog from './pullConfigDialog.vue'

export default {
  name: 'Report',
  components: { PaginationRight, pullConfigDialog },
  data() {
    return {
      tableData: [],
      total: null,
      query: {
        corp_id: null,
        page: 1,
        page_size: 10
      },
      corp_id: null,
      loading: false,
      configDialog: false
    }
  },
  computed: {
    workdays() {
      return days => {
        const weekDays = ['周日', '周一', '周二', '周三', '周四', '周五', '周六']
        // 排序并去重
        const uniqueDays = Array.from(new Set(days)).sort((a, b) => a - b)
        let result = []
        let rangeStart = null
        let rangeEnd = null
        for (let i = 0; i < uniqueDays.length; i++) {
          if (rangeStart === null) {
            rangeStart = uniqueDays[i]
          }

          if (i === uniqueDays.length - 1 || uniqueDays[i] + 1 !== uniqueDays[i + 1]) {
            rangeEnd = uniqueDays[i]

            if (rangeEnd - rangeStart >= 1) {
              // 处理连续的日期
              result.push(`${weekDays[rangeStart]}至${weekDays[rangeEnd]}`)
            } else {
              // 处理单独的日期
              result.push(weekDays[rangeStart])
            }
            rangeStart = null
          }
        }

        // 将结果用 "、" 分隔
        return result.join('、')
      }
    },
    checkTime() {
      return time => {
        const len = time.length
        if (len === 1) return `${time[0].work_sec} - ${time[0].off_work_sec}` //不分时间段
        if (len === 2) return `${time[0].work_sec} - ${time[0].off_work_sec}、${time[1].work_sec} - ${time[1].off_work_sec}` //分时间段
      }
    }
  },
  mounted() {
    this.list()
  },
  methods: {
    async list() {
      this.loading = true
      const data = await clockList(this.query)
      this.tableData = data.data.list
      this.total = data.data.total
      this.loading = false
      console.log('this.tableData', this.tableData)
    },
    //拉取配置
    async addConfig() {
      this.configDialog = true
      this.$nextTick(() => {
        this.$refs.configdialogview.send()
      })
    },
    // 新增打卡规则
    addRules() {
      this.$router.push({ path: '/TencentAccountIni/components/addClockRules' })
    },
    // 修改
    editConfig(item) {
      this.$router.push({
        query: {
          id: item.id
        },
        path: '/TencentAccountIni/components/addClockRules'
      })
    },
    //分页
    fetchCurrentPage(e) {
      this.query.page = e
      this.list()
    },
    fetchPageSize(e) {
      this.query.page_size = e
      this.list()
    },
    rowClass() {},
    update() {
      this.configDialog = false
      this.list()
    }
  },
  beforeDestroy() {
    this.tableData = []
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
:-webkit-scrollbar {
  width: 0 !important;
}
::-webkit-scrollbar {
  width: 0 !important;
  height: 0;
}
.name-item {
  margin-right: 10px;
}
.choose_allblock[data-v-101af6bb] {
  height: 284px;
  width: 410px;
}
.addbutton {
  margin-bottom: 20px;
  float: right;
}

.frame {
  width: 65%;
}
.conter {
  display: flex;
}
.senadtime {
  display: flex;
  align-items: center;
}
.taewr {
  display: flex;
  align-items: center;
}

.copy_box {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  padding-left: 34px;
}
.copy_boxr {
  display: flex;
  align-items: center;
}
.taewr {
  display: flex;
  align-items: center;
}
.tiwmebox {
  width: 50px;
  background: #f4f7f7;
  height: 36px;
  border: 1px solid #cccccc;
  border-left: 0px;
  text-align: center;
  line-height: 36px;
  color: #61686b;
  border-radius: 0px 5px 5px 0px;
}
.tiwmeboxr {
  width: 50px;
  background: #f4f7f7;
  height: 36px;
  border: 1px solid #cccccc;
  text-align: center;
  line-height: 36px;
  color: #61686b;
  border-radius: 5px;
}
.ca_boxr {
  margin-right: 17px;
  width: 50px;
  text-align: right;
  color: rgb(169, 162, 151);
  font-size: 14px;
  font-weight: 700;
}
.ca_boxre {
  width: 50px;
  text-align: right;
  margin-right: 16px;
  color: rgb(169, 162, 151);
  font-size: 14px;
  font-weight: 700;
}
::v-deep input::-webkit-outer-spin-button,
::v-deep input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
}
::v-deep input[type='number'] {
  -moz-appearance: textfield !important;
}
.tactics_box {
  padding: 20px 20px 40px 20px;
}
.sum_box {
  position: fixed;
  left: 0;
  bottom: -20px;
  margin-left: 30px;
}
.sava_box {
  position: fixed;
  bottom: 10px;
  left: 286px;
}

.senadtime {
  display: flex;
  align-items: center;
}
.el-select-dropdown.is-multiple .el-select-dropdown__item.selected::after {
  right: 0px;
}
.el-select-dropdown__list {
  width: 90%;
  padding: 19px 0;
  margin: 19px;
}
.el-select {
  width: 260px;
}

.vertical-line {
  border-left: 1px solid #ccc;
  height: 320px; /* 设置线条的高度 */
  margin-right: 15px;
}

.name-item {
  margin-right: 10px;
}
.checkbox-list {
  display: flex;
  flex-direction: column;
}
.el-col {
  width: auto;
}
.checkbox-item {
  margin-bottom: 5px;
}
.checkbox-list {
  width: 300px;
  flex-wrap: wrap;
  max-height: 300px;
  overflow-y: auto;
}
.el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: #438ff7; /* 设置背景颜色为透明 */
  border-color: #438ff7; /* 设置边框颜色为透明 */
}
.column-content {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  padding: 0 20px;
  max-height: 200px; /* 设置容器最大高度 */
  overflow-y: auto; /* 启用垂直滚动条 */
}
</style>
